export default __webpack_public_path__ + "static/media/insta.50cf6dc3.svg";